export default {
    // Indefinido
    UNDEFINED: 0,

    // Correios
    CORREIOS: 1,

    // Frete fixo
    FIXED_AMOUNT: 2,

    // Frete grátis
    FREE: 3,

    // Sem frete (Retirar na loja)
    WITHOUT_SHIPPING_PICKUP: 4,

    // Sem frete (Produto digital ou serviço)
    WITHOUT_SHIPPING: 5,

    // Loggi
    LOGGI: 6
};
